import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentOutHandoff } from '@/pages/workspaces/integrations/segment-out/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/segment_out` URL — what the integrations directory links to.
 * Flag off it renders the embedded Ember host; flag on it forwards to the migrated URL.
 */
function JourneysSegmentOutRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSegmentOutHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_out')({
  component: JourneysSegmentOutRoute,
});
